import { render, staticRenderFns } from "./ScoreRecap.vue?vue&type=template&id=0f062655&scoped=true"
import script from "./ScoreRecap.vue?vue&type=script&lang=js"
export * from "./ScoreRecap.vue?vue&type=script&lang=js"
import style0 from "./ScoreRecap.vue?vue&type=style&index=0&id=0f062655&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f062655",
  null
  
)

export default component.exports